import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faTasks } from '@fortawesome/pro-duotone-svg-icons';
import { TabPaneKey } from '../OpsCenterView';
import OpsCenterLink from '../OpsCenterLink';
import routes from 'src/routes';

export namespace HomeTab {
  export const key = '/nucleus/home' satisfies TabPaneKey;

  export const header = (
    <>
      <FontAwesomeIcon icon={faHome} /> Home
    </>
  );

  type ContentProps = {
    isRaDiagnostic: boolean | null;
  };
  export const Content: React.FC<ContentProps> = ({ isRaDiagnostic }) => {
    return (
      <>
        {' '}
        {isRaDiagnostic && (
          <OpsCenterLink to={routes.retailDiagnostic} icon={faTasks}>
            Retail Diagnostics
          </OpsCenterLink>
        )}
      </>
    );
  };
}
